import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { VizSubtitle } from '../viz.types';

interface VizSubtitleLineProps {
  subtitle?: VizSubtitle | null;
}

const VizSubtitleLine = ({ subtitle }: VizSubtitleLineProps) => {
  if (!subtitle?.scope && !subtitle?.highlight) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="baseline" sx={{ gap: 1, flexWrap: 'wrap' }}>
      {!!subtitle.scope && (
        <Typography variant="body2" color="text.tertiary">
          {subtitle.scope}
        </Typography>
      )}
      {!!subtitle.highlight && (
        <Typography variant="micro1" sx={{ color: 'custom.status.success' }}>
          {subtitle.highlight}
        </Typography>
      )}
    </Stack>
  );
};

export default VizSubtitleLine;
